var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectDetailsCalendarCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 1.99967H16.5001C16.7211 1.99967 16.9331 2.08747 17.0893 2.24375C17.2456 2.40003 17.3334 2.61199 17.3334 2.83301V16.1663C17.3334 16.3874 17.2456 16.5993 17.0893 16.7556C16.9331 16.9119 16.7211 16.9997 16.5001 16.9997H1.50008C1.27907 16.9997 1.06711 16.9119 0.910826 16.7556C0.754545 16.5993 0.666748 16.3874 0.666748 16.1663V2.83301C0.666748 2.61199 0.754545 2.40003 0.910826 2.24375C1.06711 2.08747 1.27907 1.99967 1.50008 1.99967H4.83342V0.333008H6.50008V1.99967H11.5001V0.333008H13.1667V1.99967ZM11.5001 3.66634H6.50008V5.33301H4.83342V3.66634H2.33341V6.99967H15.6667V3.66634H13.1667V5.33301H11.5001V3.66634ZM15.6667 8.66634H2.33341V15.333H15.6667V8.66634Z",
    fill: "#A1B3C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDetailsCalendarCreated);
export default __webpack_public_path__ + "static/media/project-details-calendar-created.aa37638ca2cdb246e02c913dbefd52e0.svg";
export { ForwardRef as ReactComponent };